import { z } from 'zod';

/**
 * Validation schema for the account edit form
 * Validates name and timezone fields
 */
export const accountEditSchema = z.object({
  name: z
    .string()
    .min(1, 'Account name is required')
    .max(100, 'Account name must not exceed 100 characters')
    .trim(),
  timezone: z.string().min(1, 'Timezone is required'),
});

/**
 * Inferred TypeScript type from the Zod schema
 */
export type AccountEditFormData = z.infer<typeof accountEditSchema>;
